if (!customElements.get('template-customization-form')) {
  customElements.define('template-customization-form', class TemplateCustomizationForm extends HTMLElement {
    constructor() {
      super();
      this.startingId = this.getStartingId();
      this.currentStepId = this.startingId;
      this.previousStepId = this.currentStepId;
      this.nextBtn = this.getNextBtn();
      this.prevBtn = this.getPrevBtn();
      this.addToCartBtn = this.getAddToCartBtn();
      this.form = this.getTemplateCustomizationForm();
      this.customizationOption = null;
      this.newImage = this.getNewImageInput();
      this.selectedDesign = this.getSelectedDesign();
      this.allDesigns = this.getAllDesigns();
      this.allLibraryDesigns = this.getAllLibraryDesigns();
      this.customizeButton = this.getCustomizeBtn(); 
      this.modalCloseBtn = this.getModalCloseBtn(); 
      // this.productionInfo = this.getProductionInfo();
      this.qty = 0
      this.isGolfBag = false
      // this.productionInfo.classList.remove('hidden')
      
      // Get Pulse Customize Me Button
      window.addEventListener('DOMSubtreeModified', () => {
        this.customizeMeButton = this.getCustomizeMeBtn();
      });

      this.currentColorElement = document.querySelector('variant-color-radios')
      this.currentColor = document.querySelector('input[name=Color]:checked').value
      this.excludedColors = document.querySelector('span#excluded-colors-from-customization').getAttribute('data-excluded-colors-from-customization').slice(0, -1).split(",")
      if(this.excludedColors.includes(this.currentColor)){
        this.customizeButton.classList.add('hidden')
        this.customizeMeButton.classList.add('hidden')
      }

      this.currentColorElement.addEventListener('change', () => {
        this.currentColor = document.querySelector('input[name=Color]:checked').value
        if(this.excludedColors.includes(this.currentColor)){
          this.customizeButton.classList.add('hidden')
          this.customizeMeButton.classList.add('hidden')
        } else {
          this.customizeButton.classList.remove('hidden')
          this.customizeMeButton.classList.remove('hidden')
        }
      })

      if(this.querySelector('#step-4') != null){
        this.isGolfBag = true
      }

      this.modalCloseBtn.addEventListener('click', this.closeModalX);
      window.addEventListener('click', this.closeModalOutside);

      // Checks To make sure qty entered and adds player names 
      this.customizeButton.addEventListener('click', async (e) => {
        e.preventDefault();
        this.qty = this.getQtyEntered()

        if(this.qty == 0){
          alert("No Quantity Entered");
          // this.displayErrorMessageProductForm("No Quantity Entered");
          return;
        } else {
          //When max qty reached - show alert and do not open modal 
          const formData = new FormData();
          window.variantColorRadios = new VariantColorRadios();
          let variant_qty_in_stock =0;
          let variant_id=0;
          let variant_qty=0;
          const qtyInputs = document.querySelectorAll('input.color-sizes-input');
            qtyInputs.forEach(input => {
              const name = input.getAttribute('name');
              const value = input.value;
                        
              // Only append if quantity is not 0 or empty
              if (value && parseInt(value) > 0) {
                formData.append(name, value);
              }
            });
            let form_entries = formData.entries();
            for(const entry of form_entries){
            if(entry[0].endsWith("qty")){ 
              variant_id = entry[0].split("-")[0];
              variant_qty = entry[1];
                if(variant_qty != 0){
                  const e1 = document.querySelector(`.color-sizes-current-qty[data-variant-qty-input='${entry[0]}'`);
                  const InStockqty = e1 ? Number(e1.innerText) : 0;
                  const e2 = document.querySelector(`.color-sizes-special-order-qty[data-variant-qty-input='${entry[0]}']`);
                  const SpecialOrder_qty = e2 ? Number(e2.innerText.trim()) : 0;
                  if(InStockqty==0 && SpecialOrder_qty>0) variant_qty_in_stock=SpecialOrder_qty;
                  else if(SpecialOrder_qty==0 && InStockqty>0) variant_qty_in_stock=InStockqty;
                  else if(SpecialOrder_qty>0 && InStockqty>0) variant_qty_in_stock=Number(InStockqty)+Number(SpecialOrder_qty);
                 
                  if (InStockqty > 0 && SpecialOrder_qty==0 && variant_qty > InStockqty) {
                    alert(`A maximum of ${InStockqty} items is available.Please change the quantity accordingly.`);  
                    removespinning(); 
                    return;
                  } else if (SpecialOrder_qty > 0 && InStockqty==0 && variant_qty > SpecialOrder_qty) {
                    alert(`A maximum of ${SpecialOrder_qty} items is available.Please change the quantity accordingly.`); 
                    removespinning();
                    return;
                  } else if (SpecialOrder_qty > 0 && InStockqty==0 && variant_qty > SpecialOrder_qty) {
                    alert(`A maximum of ${SpecialOrder_qty} items is available.Please change the quantity accordingly.`);
                    removespinning();
                    return;
                  }
                }
                            
                await fetch('/cart.js')
                  .then(r => r.json())
                  .then(cart => {
                  let inCartQty = 0;
                  for (let i = 0; i < cart.items.length; i++) {
                      const item = cart.items[i];
                      if (Number(item.id) === Number(variant_id)) {
                          inCartQty += Number(item.quantity || 0);
                          formData.set(`variant_id[${variant_id}]`, Number(variant_id));
                          formData.set(`total_cart_qty[${variant_id}]`, inCartQty);
                          formData.set(`entered_qty[${variant_id}]`, Number(variant_qty));
                          formData.set(`in_stock_qty[${variant_id}]`, Number(variant_qty_in_stock));       
                        }
                      }
                    });
                  }
                }
                let form_entries1 = formData.entries(); 
                let variantid,totalcartqty,instockqty,variantqty=0;
                for (const [key, value] of formData.entries()) {
                  //alert(`${key} = ${value}`);
                  if (`${key}` === `variant_id[${value}]`) {
                    variantid=`${value}`;
                    totalcartqty=formData.get(`total_cart_qty[${value}]`);
                    instockqty=formData.get(`in_stock_qty[${value}]`);
                    variantqty=formData.get(`entered_qty[${value}]`);
                  
                    if((totalcartqty == instockqty) && (totalcartqty == variantqty)) {
                      alert( `You already have all ${instockqty} available in your cart.`);
                      window.variantColorRadios.resetQty();
                      return;
                    } else if((Number(totalcartqty)+Number(variantqty))>instockqty) {
                      if((Number(instockqty)-Number(totalcartqty))==0) {
                        alert( `You already have all ${instockqty} available in your cart.`);
                        window.variantColorRadios.resetQty();
                        return;
                      } else {
                        alert(`You cannot add ${variantqty}  to your cart, there are only ${Number(instockqty)-Number(totalcartqty)} more available.`);
                        // window.variantColorRadios.resetQty();
                        return;
                      }
                    }
                  }
                }
          this.removeErrorMessageProductForm();
          this.openModal()
        }

        if(this.isGolfBag != null){
          this.addPlayerNameInputs(this.qty)
        }
      }) 

      for(let design of this.allDesigns){
        design.addEventListener('click', () => {
          // Hide all full images
          const fullDesigns = this.querySelectorAll('div.full-image img');
          for(let aFullDesign of fullDesigns){
            aFullDesign.style.display = "none";
          }

          // Display selected design
          const designName = design.getAttribute('value')
          const selectedFullDesign = this.querySelector(`div.full-image[data-design-name="${designName}"] img`)
          selectedFullDesign.style.display = "block";

          // Set ball pocket design if golf bag
          if(this.isGolfBag){
            const secondaryDesigns = this.querySelectorAll('div.secondary-image img');
            for(let aSecondaryDesign of secondaryDesigns){
              aSecondaryDesign.style.display = "none";
            }

            const selectedSecondaryDesign = this.querySelector(`div.secondary-image[data-design-name="${designName}"] img`)
            selectedSecondaryDesign.style.display = "block";
          }
        })
      }

      // remove uploaded file if design selected
      for(let libraryDesign of this.allLibraryDesigns){
        libraryDesign.addEventListener("click", () => {
          const locationId = libraryDesign.getAttribute('data-location-id')
          const matchingLibraryImage = this.querySelector(`input.new-image[data-location-id="${locationId}"]`)
          matchingLibraryImage.value = ''

          const imageFileName = this.querySelector(`input.new-image[data-location-id="${locationId}"] + label .new-image-filename`)
          const newImagePlaceholder = this.querySelector(`input.new-image[data-location-id="${locationId}"] + label .new-image-placeholder`)
          imageFileName.innerText = ''
          imageFileName.classList.add('d-none')
          newImagePlaceholder.classList.remove('d-none')
        })
      }

      this.fileInputs = this.querySelectorAll("input[type=file]")
      for(let fileInput of this.fileInputs){
        fileInput.addEventListener('change', () => {
          const imageFileName = fileInput.nextElementSibling.querySelector(".new-image-filename")
          const newImagePlaceholder = fileInput.nextElementSibling.querySelector('.new-image-placeholder')
          imageFileName.innerText = fileInput.files[0].name
          imageFileName.classList.remove('d-none')
          newImagePlaceholder.classList.add('d-none')

          // uncheck selected library design
          const locationId = fileInput.getAttribute('data-location-id')
          const matchingLibraryImage = this.querySelector(`input.library-image[data-location-id="${locationId}"]:checked`)
          matchingLibraryImage.checked = false
        })
      }

      this.nextBtn.addEventListener('click', () => {
        this.showNextStep()
      })

      this.prevBtn.addEventListener('click', () => {
        this.showPreviousStep()
      })

      this.addToCartBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.addToCart()
      })

      // Watch for changes to template customization
      const customizationOptionTemplateInput = document.querySelector('#customization-option-template')
      customizationOptionTemplateInput.addEventListener('change', () => {
        const isChecked = customizationOptionTemplateInput.checked;
        if(isChecked){
          // Reset Form
          const location = document.querySelector('input[name="location"]:checked')
          const templateCustomizationForm = document.getElementById('template-customization-form')
          templateCustomizationForm.reset()
          location.checked = true

          const newImagePlaceholderText = document.querySelector('#step-2b .new-image-placeholder')
          newImagePlaceholderText.classList.remove("d-none")

          const newImageFileNameText = document.querySelector('#step-2b .new-image-filename')
          newImageFileNameText.classList.add('d-none')
          newImageFileNameText.innerText = ''

          // Golf Bag
          if(this.isGolfBag){
            const noImage = document.querySelector('#side-pocket-no-image')
            noImage.checked = false

            // unhide player name section
            // const playerNamesSection = document.querySelector('.player-names-section')
            // playerNamesSection.classList.remove('d-none')

            // Remove placeholder text for golf bags
            const ballPocketNewImagePlaceholderText = document.querySelector('#step-4 .new-image-placeholder')
            ballPocketNewImagePlaceholderText.classList.remove("d-none")

            const ballPocketNewImageFileNameText = document.querySelector('#step-4 .new-image-filename')
            ballPocketNewImageFileNameText.classList.add('d-none')
            ballPocketNewImageFileNameText.innerText = ''
          }

          customizationOptionTemplateInput.checked = true;
        }
      })

      // Watch for changes to image customization
      const customizationOptionImageInput = document.querySelector('#customization-option-image')
      customizationOptionImageInput.addEventListener('change', () => {
        const isChecked = customizationOptionImageInput.checked;
        if(isChecked){
          // Reset Form
          const location = document.querySelector('input[name="location"]:checked')
          const templateCustomizationForm = document.getElementById('template-customization-form')
          templateCustomizationForm.reset()
          location.checked = true

          const colorBox1 = document.getElementById('color-box-1')
          const colorBox2 = document.getElementById('color-box-2')
          const outlineBox1 = document.getElementById('outline-box-1')

          colorBox1.style.backgroundColor = '#fff'
          colorBox2.style.backgroundColor = '#fff'
          if(outlineBox1 != null){
            outlineBox1.style.backgroundColor = '#fff'
          }

          if(this.isGolfBag){
            const newImagePlaceholderText = document.querySelector('#step-4 .new-image-placeholder')
            newImagePlaceholderText.classList.remove("d-none")

            const newImageFileNameText = document.querySelector('#step-4 .new-image-filename')
            newImageFileNameText.classList.add('d-none')
            newImageFileNameText.innerText = ''

            const noImage = document.querySelector('#side-pocket-no-image')
            noImage.checked = true

            // Hide Golf Bag Secondary Template Images
            const secondaryDesigns = this.querySelectorAll('div.secondary-image img');
            for(let aSecondaryDesign of secondaryDesigns){
              aSecondaryDesign.style.display = "none";
            }

            // hide player name section
            // const playerNamesSection = document.querySelector('.player-names-section')
            // playerNamesSection.classList.add('d-none')
          }

          customizationOptionImageInput.checked = true;
        }
      })
    }

    showNextStep(){
      let stepContent = this.getStepContent(this.currentStepId)
      if(this.validateStep() == false){
        console.log("Error validating step")
      } else {
        // Hide old step
        stepContent.classList.add('d-none')

        // Display New Step
        this.previousStepId = this.currentStepId
        this.currentStepId = this.getNextStepId()
        stepContent = this.getStepContent(this.currentStepId)
        stepContent.classList.remove('d-none')
        
        // Hide next btn if last step
        this.hidePrevNextBtn()
      }
    }

    showPreviousStep(){
      // Hide old step
      let stepContent = this.getStepContent(this.currentStepId)
      stepContent.classList.add('d-none')

      // Display new step
      this.currentStepId = this.getPrevStepId()
      stepContent = this.getStepContent(this.currentStepId)
      stepContent.classList.remove('d-none')

      // Hide previous btn if step 1
      this.hidePrevNextBtn()
    }

    getFormType(){
      const isBulkOrder = document.querySelector('#bulk-order-form')
      if(isBulkOrder === null){
        return false
      } else {
        return true
      }
    }

    addToCart(){
      if(this.validateStep() == false){
        console.log("Error adding to cart")
      } else {
        const productFormButton = document.querySelector('product-form')
        productFormButton.addCustomizedTemplateToCart()
        this.closeModalX()
      }
    }

    openModal(){
      const documentBody = document.body
      var modal = document.getElementById("template-customize-modal");
      modal.style.display = "block";
      documentBody.style.overflow = "hidden";
    }

    // When the user clicks on <span> (x), close the modal
    closeModalX(){
      const documentBody = document.body
      var modal = document.getElementById("template-customize-modal");
      modal.style.display = "none";
      documentBody.style.overflow = "scroll";
    }

    // When the user clicks anywhere outside of the modal, close it
    closeModalOutside(event){
      const documentBody = document.body
      var modal = document.getElementById("template-customize-modal");
      if (event.target == modal) {
        modal.style.display = "none";
        documentBody.style.overflow = "scroll";
      }
    }

    displayErrorMessage(message, stepId){
      let errorMessageElement = this.querySelector(`#${stepId} .error-message`)
      errorMessageElement.textContent = message
      errorMessageElement.classList.remove('d-none')
    }

    validateStep(){
      if(this.currentStepId == 'step-1'){
        let customizationOption = this.getCustomizationOption()
        if(customizationOption == null){
          this.displayErrorMessage("* You must select either Image or Template", "step-1")
          // this.getStepContent('step-1').classList.add('was-validated')
          return false
        } else {
          this.displayErrorMessage("","step-1")
        }
      } else if (this.currentStepId == 'step-2a'){
        let designSelection = this.getDesignSelection()
        if(designSelection == null){
          this.displayErrorMessage("* You must select a design", "step-2a")
          return false
        } else {
          this.displayErrorMessage("","step-2a")
        }
      } else if (this.currentStepId == 'step-2b'){
        if(!this.libraryDesignOrNewImageUploaded()){
          this.displayErrorMessage("* You must select a design or upload a new logo", "step-2b")
          return false
        }
        else{
          this.displayErrorMessage("", "step-2b")
        }
      } else if (this.currentStepId == 'step-3'){
        let line1 = this.getLine1()
        let color1 = this.getColor1()
        let line2 = this.getLine2()
        let color2 = this.getColor2()

        if(!line1){
          this.displayErrorMessage("* Line 1 is required", "step-3")
          return false
        } 
        else if (!color1){
          this.displayErrorMessage("* Color 1 is required", "step-3")
          return false
        } 
        else {
          this.displayErrorMessage("", "step-3")
        }
      } else if (this.currentStepId == 'step-4'){
        if(!this.libraryDesignOrNewImageUploaded()){
          this.displayErrorMessage("* You must select an image or choose 'No Image'", "step-4")
          return false
        }
        else{
          this.displayErrorMessage("", "step-4")
        }
      }
      // Validation passed!
      return true
    }

    libraryDesignOrNewImageUploaded(){
      let selectedEmbroideryImage = this.querySelector('input.library-image:checked')
      let uploadedImage = this.querySelector("input[name='New Image']")

      if(selectedEmbroideryImage == null && uploadedImage.value == ''){
        if(this.isGolfBag){
          let uploadedBallPocketImage = this.querySelector("input[name='Ball Pocket New Image']")
          if(uploadedBallPocketImage.value == ''){
            return false
          }
        }else {
          return false
        }
      } 

      return true
    }

    hidePrevNextBtn(){
      // Hide the prev button if step 1
      if(this.currentStepId == this.startingId){
        this.prevBtn.classList.add('d-none')
      }  else {
        this.prevBtn.classList.remove('d-none')
      }

      // Hide the next button if step 3 or step 2b
      if(this.currentStepId == 'step-2b' && this.isGolfBag == false){
        this.nextBtn.classList.add('d-none')
        this.addToCartBtn.classList.remove('d-none')
      }
      else if(this.currentStepId == 'step-3' && this.isGolfBag == false){
        this.nextBtn.classList.add('d-none')
        this.addToCartBtn.classList.remove('d-none')
      } else if(this.currentStepId == 'step-4') {
        this.nextBtn.classList.add('d-none')
        this.addToCartBtn.classList.remove('d-none')
      }   
      else {
        this.nextBtn.classList.remove('d-none')
        this.addToCartBtn.classList.add('d-none')
      }
    }

    getNextStepId(){
      if(this.currentStepId == 'step-0'){
        return 'step-1'
      } else if(this.currentStepId == 'step-1'){
        if(this.getCustomizationOption() == 'template'){
          return 'step-2a'
        } else {
          return 'step-2b'
        }
      } else if (this.currentStepId == 'step-2a'){
        return 'step-3'
      } else if (this.currentStepId == 'step-2b' && this.isGolfBag == true) {
        return 'step-4'
      } else if (this.currentStepId == 'step-3'){
        return 'step-4'
      }
    }

    getPrevStepId(){
      if(this.currentStepId == 'step-1'){
        return 'step-0'
      } else if(this.currentStepId == 'step-2a' || this.currentStepId == 'step-2b'){
        return 'step-1'
      } else if (this.currentStepId == 'step-3'){
        return 'step-2a'
      } else if (this.currentStepId == 'step-4'){
        if(this.previousStepId == 'step-2b'){
          return this.previousStepId;
        }else {
          return 'step-3'
        }
      }
    }

    getStepContent(stepId){
      return this.querySelector(`#${stepId}`)
    }

    getCustomizationOption(){
      const customizationOption = this.querySelector('input[name="customization-option"]:checked')
      if(customizationOption == null){
        return null
      } else {
        return customizationOption.value
      }
    }

    getDesignSelection(){
      const designSelection = this.querySelector('input[name="design"]:checked')
      if(designSelection == null){
        return null
      } else {
        return designSelection.value
      }
    }

    getLine1(){
      const line1 = this.querySelector('input[name="line1"]')
      return line1.value
    }

    getColor1(){
      const color1 = this.querySelector('select[name="color1"] option:checked')
      if(color1 == null){
        return null
      } else {
        return color1.value
      }
    }

    getLine2(){
      const line2 = this.querySelector('input[name="line2"]')
      return line2.value
    }

    getColor2(){
      const color2 = this.querySelector('select[name="color2"] option:checked')
      if(color2 == null){
        return null
      } else {
        return color2.value
      }
    }

    getStartingId(){
      const startingId = this.querySelector('.start').id;
      return startingId;
    }

    getNextBtn(){
      const nextBtn = this.querySelector('#next-button');
      return nextBtn;
    }

    getPrevBtn(){
      const prevBtn = this.querySelector('#prev-button');
      return prevBtn;
    }

    getAddToCartBtn(){
      const addToCartBtn = this.querySelector('#template-customize-add-to-cart');
      return addToCartBtn;
    }

    getCustomizeBtn(){
      const customizeBtn = document.querySelector('#open-template-customize-modal');
      return customizeBtn;
    }

    // getProductionInfo(){
    //   const prodInfo = document.querySelector('#production-info');
    //   return prodInfo;
    // }
    
    getCustomizeMeBtn(){
      const customizeMeBtn = document.querySelector('.personalize-button');

      const config = { attributes: true, childList: true, subtree: true };

      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            console.log("A child node has been added or removed.");
          } else if (mutation.type === "attributes") {
            console.log(`The ${mutation.attributeName} attribute was modified.`);
          }
        }
      };

      const observer = new MutationObserver(callback);

      observer.observe(customizeMeBtn, config);

      return customizeMeBtn;
    }

    getTemplateCustomizationForm(){
      const templateCustomizationForm = this.querySelector('#template-customization-form');
      return templateCustomizationForm;
    }

    getNewImageInput(){
      const newImageInput = this.querySelector("#new-image");
      return newImageInput;
    }

    getSelectedDesign(){
      const selectedDesign = this.querySelector("#selected-design");
      return selectedDesign;
    }

    getAllDesigns(){
      const allDesigns = this.querySelectorAll('input[name="design"]');
      return allDesigns;
    }

    getAllLibraryDesigns(){
      const allLibraryDesigns = this.querySelectorAll('input.library-image');
      return allLibraryDesigns;
    }

    getModalCloseBtn(){
      const modalCloseBtn = document.getElementsByClassName("close")[0];
      return modalCloseBtn;
    }

    getQtyEntered(){
      const qtyInputs = document.querySelectorAll('input.color-sizes-input')
      this.qty = 0

      for(let qtyInput of qtyInputs){
        this.qty += +qtyInput.value
      }
      return this.qty
    }

    displayErrorMessageProductForm(message){
      let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
      let errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
      errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      errorMessage.textContent = message;
    }

    removeErrorMessageProductForm(){
      let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
      let errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
      errorMessageWrapper.toggleAttribute('hidden', errorMessage);
    }

    addPlayerNameInputs(num_player_names){
      const playerNamesContainer = this.querySelector('#player-names-container')
      playerNamesContainer.innerHTML = ''
      for(let i = 0; i < num_player_names; ++i){
        let playerNameHtml = `<div class="player-name-field">\
          <label for="player-name-${i+1}" style="border: none;">Golf Bag ${i+1}:</label>\
          <input id="player-name-${i+1}" name="player-name-${i+1}" placeholder="ADD TEXT (eg. Player Name)" type="text" style="height: 40px;">\
        </div>`
        playerNamesContainer.innerHTML += playerNameHtml
      }
    }
  })
}